var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#3B6072"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.76 510.43c17 0 30.24-13.78 30.24-31.36V32.93c0-17.58-13.28-31.36-30.25-31.36a32.728 32.728 0 0 0-16.3 4.49L128.61 229.12c-10.07 5.81-16.08 15.88-16.08 26.88 0 11 6 21.07 16.08 26.87l336.84 223.07a32.72 32.72 0 0 0 16.3 4.49h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.94 499.51a61.94 61.94 0 0 0 61.94-61.93V74.42A61.94 61.94 0 0 0 0 74.42v363.16a61.94 61.94 0 0 0 61.94 61.93Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPrev);
export default __webpack_public_path__ + "static/media/play-prev.b925e9a1c221047ef99dde1be0b094dd.svg";
export { ForwardRef as ReactComponent };